import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class UpgradeAccountError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('UpgradeAccountError', ...args);
    }
}
export default UpgradeAccountError;
